import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAdminAuth } from "@/lib/adminAuth";
import { toast } from "sonner";
import Logo from "@/components/landing/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white p-6">
      <motion.form
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        onSubmit={submit}
        className="w-full max-w-md space-y-5"
        data-testid="admin-login-form"
      >
        <div className="flex flex-col items-center gap-3 mb-2">
          <Logo size={64} />
          <h1 className="font-['Outfit'] text-3xl mt-2">Admin login</h1>
          <p className="text-sm text-gray-500">Reflections Auto Detailing</p>
        </div>

        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          data-testid="admin-email"
          className="bg-white/[0.03] border-white/10 text-white h-12"
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid="admin-password"
          className="bg-white/[0.03] border-white/10 text-white h-12"
        />
        <Button
          type="submit"
          disabled={loading}
          data-testid="admin-submit"
          className="w-full h-12 bg-sky-500 hover:bg-sky-400 text-white"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
        </Button>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="block w-full text-center text-sm text-gray-500 hover:text-white"
        >
          ← Back to site
        </button>
      </motion.form>
    </div>
  );
}
